module.exports = __webpack_public_path__ + "static/media/card-bg2.b552bf12.png";